import React from "react";
import { Layout, Form, Input } from "antd";
import DataTable, { defaultThemes } from "react-data-table-component";
const { Content } = Layout;

const SecurityPolicy = () => {
  const [form] = Form.useForm();

  const paramCol = [
    {
      name: "พารามิเตอร์",
      selector: (row) => row.param,
      center: true,
      sortable: true,
    },
    {
      name: "ประเภทข้อมูล",
      selector: (row) => row.value,
      center: true,
      sortable: true,
    },
    {
      name: "คำอธิบาย",
      selector: (row) => row.desc,
      center: true,
      sortable: true,
    },
  ];

  const parameter = [
    {
      id: 1,
      param: "day",
      value: "char",
      operator: "",
      desc: "วันเดือนปีรูปแบบ 10-02-2023",
    },
    {
      id: 2,
      param: "channel",
      value: "char",
      operator: "",
      desc: "Channel ID (ระบุช่องโทรทัศน์ หรือ สถานีวิทยุ)",
    },
  ];

  const parameterPlayList = [
    {
      id: 1,
      param: "playlist",
      value: "char",
      operator: "",
      desc: "Playlist ID (ระบุ ID ของเพลย์ลิสต์)",
    },
  ];

  const successCol = [
    {
      name: "Result",
      selector: (row) => row.result,
      center: true,
      sortable: true,
    },
    {
      name: "ประเภทข้อมูล",
      selector: (row) => row.value,
      center: true,
      sortable: true,
    },
    {
      name: "คำอธิบาย",
      selector: (row) => row.desc,
      center: true,
      width: "400px",
      sortable: true,
    },
  ];

  const success = [
    {
      id: 1,
      result: "id",
      value: "char",
      desc: "ID ของช่องรายการ",
    },
    {
      id: 2,
      result: "type",
      value: "char",
      desc: "ประเภทของช่องรายการ (Live = ช่องโทรทัศน์, Radio = สถานีวิทยุ)",
    },
    {
      id: 3,
      result: "title",
      value: "char",
      desc: "ชื่อช่องรายการ",
    },
    {
      id: 4,
      result: "desc",
      value: "char",
      desc: "รายละเอียดของช่องรายการ",
    },
    {
      id: 5,
      result: "thumbnail",
      value: "char",
      desc: "URL แสดงรูปตัวอย่างของช่องรายการ",
    },
  ];
  const successPlayList = [
    {
      id: 1,
      result: "id",
      value: "char",
      desc: "ID ของรายการเพลย์ลิสต์",
    },
    {
      id: 2,
      result: "name",
      value: "char",
      desc: "ชื่อรายการเพลย์ลิสต์",
    },
    {
      id: 3,
      result: "description",
      value: "char",
      desc: "รายละเอียด",
    },
    {
      id: 4,
      result: "total",
      value: "char",
      desc: "จำนวนวิดีโอในเพลย์ลิสต์",
    },
    {
      id: 5,
      result: "url",
      value: "char",
      desc: "URL ของรายการเพลย์ลิสต์",
    },
    {
      id: 6,
      result: "createdAt",
      value: "date",
      desc: "เวลาสร้างเพลย์ลิสต์",
    },
    {
      id: 7,
      result: "updateAt",
      value: "date",
      desc: "แก้ไขเพลย์ลิสต์ล่าสุด",
    },
  ];
  const successPlayListDetail = [
    {
      id: 1,
      result: "id",
      value: "char",
      desc: "ID ของรายการเพลย์ลิสต์",
    },
    {
      id: 2,
      result: "name",
      value: "char",
      desc: "ชื่อรายการเพลย์ลิสต์",
    },
    {
      id: 3,
      result: "description",
      value: "char",
      desc: "รายละเอียด",
    },
    {
      id: 4,
      result: "total",
      value: "char",
      desc: "จำนวนวิดีโอในเพลย์ลิสต์",
    },
    {
      id: 5,
      result: "url",
      value: "char",
      desc: "URL ของรายการเพลย์ลิสต์",
    },
    {
      id: 6,
      result: "createdAt",
      value: "date",
      desc: "เวลาสร้างเพลย์ลิสต์",
    },
    {
      id: 7,
      result: "updateAt",
      value: "date",
      desc: "แก้ไขเพลย์ลิสต์ล่าสุด",
    },
  ];

  const successPlayListVDO = [
    {
      id: 1,
      result: "id",
      value: "char",
      desc: "ID ของรายการวิดีโอ",
    },
    {
      id: 2,
      result: "name",
      value: "char",
      desc: "ชื่อรายการวิดีโอ",
    },
    {
      id: 3,
      result: "description",
      value: "char",
      desc: "รายละเอียด",
    },
    {
      id: 5,
      result: "url",
      value: "char",
      desc: "URL ของรายการวิดีโอ",
    },
    {
      id: 6,
      result: "createdAt",
      value: "date",
      desc: "เวลาสร้างวิดีโอ",
    },
    {
      id: 7,
      result: "updateAt",
      value: "date",
      desc: "แก้ไขวิดีโอล่าสุด",
    },
  ];

  const programCol = [
    {
      name: "ชื่อฟิลด์",
      selector: (row) => row.field,
      center: true,
      sortable: true,
    },
    {
      name: "ประเภทข้อมูล",
      selector: (row) => row.value,
      center: true,
      sortable: true,
    },
    {
      name: "คำอธิบาย",
      selector: (row) => row.desc,
      center: true,
      sortable: true,
    },
  ];

  const program = [
    {
      id: 1,
      field: "id",
      value: "char",
      desc: "ID ของรายการ",
    },
    {
      id: 2,
      field: "name",
      value: "Array",
      desc: "ชื่อรายการ",
    },
    {
      id: 3,
      field: "day",
      value: "char",
      desc: "วันที่ ออกอากาศ",
    },
    {
      id: 4,
      field: "schedule",
      value: "char",
      desc: "เวลา ออกอากาศ",
    },
    {
      id: 5,
      field: "start",
      value: "date",
      desc: "เริ่มรายการ (timestamp)",
    },
    {
      id: 6,
      field: "stop",
      value: "date",
      desc: "จบรายการ (timestamp)",
    },
    {
      id: 7,
      field: "start_date",
      value: "date",
      desc: "เริ่มรายการ",
    },
    {
      id: 8,
      field: "stop_date",
      value: "date",
      desc: "จบรายการ",
    },
    {
      id: 9,
      field: "createdAt",
      value: "date",
      desc: "เวลาสร้างผังรายการ",
    },
    {
      id: 10,
      field: "updateAt",
      value: "date",
      desc: "แก้ไขผังรายการล่าสุด",
    },
  ];

  const errorCol = [
    {
      name: "ตัวแปร",
      selector: (row) => row.param,
      center: true,
      sortable: true,
    },
    {
      name: "ประเภทข้อมูล",
      selector: (row) => row.value,
      center: true,
      sortable: true,
    },
    {
      name: "คำอธิบาย",
      selector: (row) => row.desc,
      center: true,
      sortable: true,
    },
  ];

  const error = [
    {
      id: 1,
      param: "status",
      value: "Boolean",
      desc: "จริงหรือเท็จ",
    },
    {
      id: 2,
      param: "result",
      value: "Boolean",
      desc: "จริงหรือเท็จ",
    },
    {
      id: 3,
      param: "message",
      value: "String",
      desc: "ข้อความ",
    },
  ];

  const customStyles = {
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopColor: defaultThemes.default.divider.default,
        borderTopWidth: "1px",
        backgroundColor: "#6C4099",
        color: "#fff",
      },
    },
    // rows: {
    //     style: {
    //         minHeight: '72px', // override the row height
    //     },
    // },
    headCells: {
      style: {
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
        fontSize: "20px",
        fontWeight: "600",
        borderRightStyle: "solid",
        borderRightWidth: "1px",
        // borderLeftStyle: 'solid',
        borderLeftWidth: "1px",
        borderLeftColor: defaultThemes.default.divider.default,
        borderRightColor: defaultThemes.default.divider.default,
        borderTopColor: defaultThemes.default.divider.default,
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
        fontSize: "20px",
        borderRightStyle: "solid",
        borderRightWidth: "1px",
        // borderLeftStyle: 'solid',
        borderLeftWidth: "1px",
        borderLeftColor: defaultThemes.default.divider.default,
        borderRightColor: defaultThemes.default.divider.default,
        borderTopColor: defaultThemes.default.divider.default,
      },
    },
  };

  const onFinishLogin = (values) => {
    // console.log("Received values of form: ", values);
  };
  return (
    <>
      <Layout className="layout">
        <Content
          // className="content-layout"
          style={{
            minHeight: "100vh",
            backgroundColor: "#493E5E",
          }}
        >
          <div
            className="main-container container-api"
            style={{
              marginTop: "60px",
              color: "#fff",
              fontSize: "18px",
              background: "#372F48",
            }}
          >
            <h1
              style={{ color: "#fff", fontWeight: "600", marginBottom: "5px" }}
            >
              บริการข้อมูล API
            </h1>
            <h1
              style={{ color: "#fff", fontWeight: "600", marginBottom: "20px" }}
            >
              Electronic Program Guide
            </h1>

            <Form
              form={form}
              name="normal_login"
              // className="login-form"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinishLogin}
            >
              <label
                style={{
                  color: "#fff",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "0",
                }}
              >
                1. API HOST
              </label>
              <Form.Item name="api">
                <Input
                  className="input-login"
                  placeholder="API"
                  style={{ fontSize: "22px" }}
                  defaultValue="https://api-ott.prd.go.th"
                  readOnly
                />
              </Form.Item>

              <label
                style={{
                  color: "#fff",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "0",
                }}
              >
                2. CHANNEL
              </label>
              <Form.Item name="method">
                <Input
                  className="input-login"
                  placeholder="Method"
                  style={{ fontSize: "22px" }}
                  defaultValue="GET /api/v1/epg/channel"
                  readOnly
                />
              </Form.Item>

              <h2 style={{ color: "#fff" }}>Success: 200</h2>
              <div style={{ position: "relative", marginBottom: "30px" }}>
                <DataTable
                  customStyles={customStyles}
                  style={{ borderRadius: "0" }}
                  columns={successCol}
                  data={success}
                  striped={true}
                />
              </div>

              <label
                style={{
                  color: "#fff",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "0",
                }}
              >
                3. PROGRAME
              </label>
              <Form.Item name="method">
                <Input
                  className="input-login"
                  placeholder="Method"
                  style={{ fontSize: "22px" }}
                  defaultValue="POST /api/v1/epg/program"
                  readOnly
                />
              </Form.Item>

              <h2 style={{ color: "#fff" }}>Parameter</h2>
              <div style={{ position: "relative", marginBottom: "30px" }}>
                <DataTable
                  customStyles={customStyles}
                  style={{ borderRadius: "0" }}
                  columns={paramCol}
                  data={parameter}
                  striped={true}
                />
              </div>

              <h2 style={{ color: "#fff" }}>Programs</h2>
              <div style={{ position: "relative", marginBottom: "30px" }}>
                <DataTable
                  customStyles={customStyles}
                  style={{ borderRadius: "0" }}
                  columns={programCol}
                  data={program}
                  striped={true}
                />
              </div>

              <label
                style={{
                  color: "#fff",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "0",
                }}
              >
                4. PLAYLIST
              </label>
              <Form.Item name="method">
                <Input
                  className="input-login"
                  placeholder="Method"
                  style={{ fontSize: "22px" }}
                  defaultValue="GET /api/v1/playlist/all"
                  readOnly
                />
              </Form.Item>

              <h2 style={{ color: "#fff" }}>Success: 200</h2>
              <div style={{ position: "relative", marginBottom: "30px" }}>
                <DataTable
                  customStyles={customStyles}
                  style={{ borderRadius: "0" }}
                  columns={successCol}
                  data={successPlayList}
                  striped={true}
                />
              </div>

              <label
                style={{
                  color: "#fff",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "0",
                }}
              >
                5. PLAYLIST DETAIL
              </label>
              <Form.Item name="method">
                <Input
                  className="input-login"
                  placeholder="Method"
                  style={{ fontSize: "22px" }}
                  defaultValue="POST /api/v1/playlist/detail"
                  readOnly
                />
              </Form.Item>

              <h2 style={{ color: "#fff" }}>Parameter</h2>
              <div style={{ position: "relative", marginBottom: "30px" }}>
                <DataTable
                  customStyles={customStyles}
                  style={{ borderRadius: "0" }}
                  columns={paramCol}
                  data={parameterPlayList}
                  striped={true}
                />
              </div>

              <h2 style={{ color: "#fff" }}>Playlist</h2>
              <div style={{ position: "relative", marginBottom: "30px" }}>
                <DataTable
                  customStyles={customStyles}
                  style={{ borderRadius: "0" }}
                  columns={successCol}
                  data={successPlayListDetail}
                  striped={true}
                />
              </div>

              <h2 style={{ color: "#fff" }}>Videos</h2>
              <div style={{ position: "relative", marginBottom: "30px" }}>
                <DataTable
                  customStyles={customStyles}
                  style={{ borderRadius: "0" }}
                  columns={successCol}
                  data={successPlayListVDO}
                  striped={true}
                />
              </div>

              <h2 style={{ color: "#fff" }}>Error: 4xx</h2>
              <div style={{ position: "relative", marginBottom: "30px" }}>
                <DataTable
                  customStyles={customStyles}
                  style={{ borderRadius: "0" }}
                  columns={errorCol}
                  data={error}
                  striped={true}
                />
              </div>
            </Form>
          </div>
        </Content>
      </Layout>
    </>
  );
};

export default SecurityPolicy;
